import React from 'react';
import { motion } from 'framer-motion';

import { Spinner } from './Spinner';

import styles from './Button.module.css';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
  fullWidth?: boolean;
  children: React.ReactNode;
}

const SPINNER_COLOR_BY_VARIANT: Record<ButtonVariant, string> = {
  primary: '#FFFFFF',
  secondary: 'var(--fg-default)',
  ghost: 'var(--fg-default)',
  danger: '#FFFFFF',
};

export function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  fullWidth = false,
  disabled,
  children,
  className,
  type = 'button',
  ...rest
}: ButtonProps) {
  const isDisabled = disabled || loading;
  const spinnerColor = SPINNER_COLOR_BY_VARIANT[variant];

  return (
    <motion.button
      type={type}
      disabled={isDisabled}
      className={[
        styles.button,
        styles[variant],
        styles[size],
        fullWidth && styles.fullWidth,
        loading && styles.loading,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      whileTap={isDisabled ? undefined : { scale: 0.98 }}
      {...rest}
    >
      {loading ? (
        <>
          <Spinner size="sm" color={spinnerColor} />
          <span className={styles.loadingText}>{children}</span>
        </>
      ) : (
        children
      )}
    </motion.button>
  );
}
